<template>
  <div class="home">
    <banner />
    <home-index />
    <!-- <div class="fixed-router">
      <div class="fixed-router-item">媒体报道</div>
      <div class="fixed-router-item">服务条款</div>
      <div class="fixed-router-item">帮助中心</div>
      <div class="fixed-router-item">视频教程</div>
    </div> -->
  </div>
</template>

<script>
// @ is an alias to /src.container
import banner from '../components/banner'
import homeIndex from './components/homeIndex'
export default {
  name: 'Home',
  components: {
    banner,
    homeIndex
  },
  data(){
    return{
    }
  },
  computed:{
  },
  created(){
  }
}
</script>

<style scoped lang="scss">
.home{
  background:#f4f4f4;
  position: relative;
}
.fixed-router{
  position: fixed;
  bottom: 30px;
  right: 70px;
  z-index: 9999;
}
.fixed-router-item{
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  background:#fff;
  margin-bottom: 10px;
  cursor: pointer;
}
.fixed-router-item:hover{
  color:#ce1212;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue